module.exports = "<div id=\"loading\" class=\"pena-load\">\r\n    <img src=\"assets/images/default/pena-logo-color-animate.svg\">\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/Work-Local/frontend/src/app/_shared/layout/loading-page/loading-page.component.html
// module id = ../../../../../src/app/_shared/layout/loading-page/loading-page.component.html
// module chunks = main